/* eslint-disable no-use-before-define */ import _ from 'lodash';
import { safeToBig } from 'shared/helpers/utils_math';
import { getProductNetWeightInGrams } from 'shared/helpers/products';
import { getFlowerEquivalent } from 'shared/helpers/check-limits';
import { getTypeLimits, getLimitMessage, getEffectiveSubcategories } from '../utils';
export function isSolidEdible(product) {
    var useMultiSubcategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var type = product.type;
    var isLiquid = _.includes(getEffectiveSubcategories(product, useMultiSubcategories), 'drinks');
    return type === 'Edible' && !isLiquid;
}
export function checkSolidEdibleNetWeight(cart) {
    var solidEdibleNetWeightLimit = getTypeLimits(cart).solidEdibleNetWeightLimit;
    var weightInGrams = getTotalSolidGramsForCart(cart);
    var message = getLimitMessage('solid edibles', solidEdibleNetWeightLimit);
    return weightInGrams > solidEdibleNetWeightLimit ? {
        total: weightInGrams,
        message: message,
        withinLimits: false
    } : {
        withinLimits: true
    };
}
export function getTotalSolidGramsForCart(param) {
    var orders = param.orders, state = param.state, limits = param.limits, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories;
    return Number(_.reduce(orders, function(previous, order) {
        var product = order.product, quantity = order.quantity;
        if (!isSolidEdible(product, useMultiSubcategories)) {
            return safeToBig(previous);
        }
        var netWeightInGrams = getProductNetWeightInGrams(product);
        var totalNetWeight = netWeightInGrams * quantity;
        var isBritishColumbiaDispensary = state === 'BC';
        var flowerEquivalent = getFlowerEquivalent(order, medical, limits, useMultiSubcategories);
        var useEquivalent = isBritishColumbiaDispensary && !!flowerEquivalent;
        return safeToBig(previous).plus(useEquivalent ? flowerEquivalent : totalNetWeight);
    }, 0.0));
}
